import React from "react";
import { graphql } from "react-apollo";
import { contactDisplayName } from "../../../utils/helpers";
import { gql } from "apollo-boost";

import StatusLabel from "../../StatusLabel";
import PostedTurnaround from "../../PostedTurnaround";
import Loader from "../../PulseLoader";
import { Table, TableRow, TableCell } from "../../Table";
import EmptyMessage from "../../EmptyMessage";
import Link from "../../Link";

const STATUS_ORDER = ["in_production", "on_hold"];

class CertifiedQueue extends React.Component {
  componentDidMount() {
    if (this.props.data) {
      this.props.data.refetch();
    }
  }

  renderService = service => {
    const job = service.job;
    const { contact } = job;
    const contactName = contactDisplayName(contact);
    const link = `/admin/jobs/${job.id}/services/${service.id}`;

    return (
      <TableRow key={service.id} onHold={service.status === "on_hold"}>
        <TableCell>
          <Link to={link} style={{ fontWeight: 600 }}>
            {contactName}
          </Link>
        </TableCell>
        <TableCell>
          {service.postedTurnaroundDate && (
            <PostedTurnaround>{service.postedTurnaroundDate}</PostedTurnaround>
          )}
        </TableCell>
        <TableCell>{service.structureType}</TableCell>
        <TableCell>
          <StatusLabel status={service.status} />
        </TableCell>
      </TableRow>
    );
  };

  render() {
    if (this.props.data) {
      const { loading, services } = this.props.data;

      if (loading) {
        return <Loader />;
      }

      if (!services || !services.length) {
        return (
          <EmptyMessage>
            It looks like the certified queue is empty!
          </EmptyMessage>
        );
      }

      const sortedServices = services.slice().sort((a, b) => {
        const byStatus =
          STATUS_ORDER.indexOf(a.status) - STATUS_ORDER.indexOf(b.status);

        if (byStatus === 0) {
          if (!a.postedTurnaroundDate) return 1;
          if (!b.postedTurnaroundDate) return -1;
          return (
            new Date(a.postedTurnaroundDate) - new Date(b.postedTurnaroundDate)
          );
        }

        return byStatus;
      });

      return (
        <Table>
          <TableRow header>
            <TableCell style={{ width: "36%" }} />
            <TableCell>Estimated Turnaround</TableCell>
            <TableCell>Structure</TableCell>
            <TableCell>Status</TableCell>
          </TableRow>
          {sortedServices.map(this.renderService)}
        </Table>
      );
    }

    return null;
  }
}

const CertifiedQueueQuery = gql`
  query CertifiedQueueQuery {
    services(queue: "certified") {
      id
      serviceType
      submittedAt
      status
      structureType
      postedTurnaroundDate
      job {
        id
        contractNumber
        contact {
          id
          firstName
          lastName
          otherFirstName
          otherLastName
        }
        franchise {
          id
          name
        }
      }
    }
  }
`;

export default graphql(CertifiedQueueQuery, {
  options: { pollInterval: 1000 * 30 }
})(CertifiedQueue);



// WEBPACK FOOTER //
// ./src/components/admin/Dashboard/CertifiedQueue.js